import { service } from "@/services/api.ts";
import { IUIConfigState } from "@/types/common";
import {
  GetViewJobItemDetailRequest,
  GetViewJobItemDetailResponse,
  GetViewJobItemUIConfigResponse,
  ViewJobItemDetailFilterResponse,
  ViewJobItemDetailFiltersRequest
} from "@/types/majorProjects/jobItemsList";

const urlViewJobItemDetailService = "customers/major-project/view-item/job-item";

export const viewJobItemDetailService = {
  getViewJobItemDetailFilters: (params: ViewJobItemDetailFiltersRequest) =>
    service.post<ViewJobItemDetailFilterResponse>(urlViewJobItemDetailService + "/filters", params),
  getViewJobItemDetailUIConfig: () => service.get<GetViewJobItemUIConfigResponse>("/uiConfigs/MajorProject_JobItem"),
  updateViewJobItemDetailUIConfig: (params: IUIConfigState) => service.put<GetViewJobItemUIConfigResponse>("/uiConfigs", params),
  exportCSV: (params: GetViewJobItemDetailRequest) => service.post(urlViewJobItemDetailService + "/exportCsv", params, { responseType: "blob" }),
  getViewJobItemDetail: (params: GetViewJobItemDetailRequest) =>
    service.post<GetViewJobItemDetailResponse>(urlViewJobItemDetailService + "/search", params)
};
